import { addMinutes } from "date-fns";
import {
  hashCode,
  isValidDate,
  kestoString,
  pvmStringLong,
  viikonpv,
} from "src/components/js/statics1";
import vehicleClass from "../components/vehicle/vehicleClass";
import { pumpparit_fetchList_for_keikka } from "src/components/pumppari/PumppariFunctions";

export default class pumppuClass {
  constructor(keikkaId) {
    this.vehicle = new vehicleClass(0);
    this.keikkaId = keikkaId;
    this.pumppuPuomi = -1;
    this.pumppuLinja = -1;
    this.pumppuAika = null;
    this.pumppuKesto = null;
    this.pumppuNimi = null;
    this.originalHash = "";
    this.originalAika = null;
    this.pumppariList = undefined;
    this.kellonAikaTxt = "";
    this.ehdotaAikaa = false;
    this.tyhjänäTyömaalle = null;
    this.betoniAika = null;
  }

  initPumppariList = async (token) => {
    const l = await pumpparit_fetchList_for_keikka(this.keikkaId, token);
    this.pumppariList = l;
    return;
  };

  get isPumi() {
    return this.pumppuPuomi < 34;
  }
  get isPumppu() {
    return this.pumppuPuomi > 33;
  }

  get linjaString() {
    if (this.pumppuLinja < 0 || this.pumppuLinja == null) return "";
    var linja = "Linjaa " + this.pumppuLinja + "m ";
    if (this.pumppuLinja === 0 && this.pumppuPuomi > 0) {
      linja = "Roikosta";
    } else if (this.pumppuLinja === 0 && this.pumppuPuomi === 0) {
      linja = "Ei linjaa ";
    }
    return linja;
  }
  get linjaStringLong() {
    if (this.pumppuLinja < 0 || this.pumppuLinja == null) return "";
    if (this.pumppuPuomi === 0 && this.pumppuLinja === 0) return "";
    var linja = "Linjaa " + this.pumppuLinja + " metriä ";
    if (this.pumppuLinja === 0 && this.pumppuPuomi > 0) {
      linja = "Roikosta, ei linjaa";
    } else if (this.pumppuLinja === 0 && this.pumppuPuomi === 0) {
      linja = "Ei linjaa ";
    }
    return linja;
  }
  get linjaHelpTxt() {
    if (this.pumppuLinja > 30)
      return "Pumppari avustaa asiakasta irtolinjan rakennuksessa ja purkamisessa.";
    return "";
  }
  get pumppuString() {
    if (this.pumppuPuomi < 0 || this.pumppuPuomi == null) return "";
    if (this.pumppuPuomi === 0) return "Ei puomia";

    var puomiTxt = this.pumppuPuomi + "m ";
    var a = (this.pumppuPuomi > 33 ? "Pumppu " : "Pumi ") + puomiTxt;
    return a;
  }
  get pumppuStringLong() {
    if (this.pumppuPuomi < 0 || this.pumppuPuomi == null) return null;
    if (this.pumppuPuomi === 0 && !this.pumppuLinja)
      return "Ei puomia, perästä pumppaus, linja ei tiedossa";
    if (this.pumppuPuomi === 0) return "Ei puomia, perästä pumppaus";
    var puomiTxt = this.pumppuPuomi + " metrin puomilla";
    var a = (this.pumppuPuomi > 33 ? "Pumppu " : "Pumi ") + puomiTxt;
    return a;
  }
  get pumppuPvmStringLong() {
    if (this.ehdotaAikaa) return "";
    if (isValidDate(this.pumppuAika)) {
      const vk = viikonpv(this.pumppuAika);
      const pvm = pvmStringLong(this.pumppuAika);
      return vk + " " + pvm;
    } else {
      return "";
    }
  }
  get pumppuKestoStringLong() {
    if (this.ehdotaAikaa) return "";
    if (isValidDate(this.pumppuAika)) {
      return kestoString(this.pumppuAika, this.pumppuKesto);
    } else {
      return "";
    }
  }
  get pumppuAikaStringLong() {
    if (this.ehdotaAikaa) return "";
    if (isValidDate(this.pumppuAika)) {
      return this.pumppuPvmStringLong + " klo " + this.pumppuKestoStringLong;
    } else {
      return "";
    }
  }
  get ylijaamaBetoniLinja() {
    // PI*r*r
    // Irtolinjan betoni
    const linja = Math.round(this.pumppuLinja / 10) * 10;
    const pi = Math.PI;
    let d = 2; // tuumaa
    if (this.pumppuLinja > 70) d = 3;
    else if (this.pumppuLinja > 20) d = 2 + (this.pumppuLinja - 20) / 50;
    const r = (d / 2) * 2.5;

    return Math.ceil((linja * pi * r * r) / 100) * 10;
  }

  get aloitusAika() {
    return this.pumppuAika;
  }

  get lopetusAika() {
    return addMinutes(this.pumppuAika, this.pumppuKesto);
  }

  get lopetusAikaIsInPast() {
    return this.lopetusAika < new Date();
  }

  get ylijaamaBetoniPuomi() {
    // PI*r*r
    const autonPituus = 13; // 13m
    let minLitra = 150;
    if (this.pumppuPuomi === 0) minLitra = 0;
    const pi = Math.PI;
    let d = 4; // tuumaa
    if (this.pumppuPuomi > 33) d = 5;
    const r = (d / 2) * 2.5;
    return Math.max(
      minLitra,
      Math.ceil(((this.pumppuPuomi + autonPituus) * pi * r * r) / 500) * 50
    );
  }
  get pumppuIsModified() {
    return this.pumppuHash() !== this.originalHash;
  }
  get isPuomiSelected() {
    return this.pumppuPuomi !== null && this.pumppuPuomi > -1;
  }
  get isLinjaSelected() {
    return this.pumppuLinja !== null && this.pumppuLinja > -1;
  }
  puomiError(allowEdit = true) {
    if (this.pumppuPuomi < 0 || this.pumppuPuomi == null) {
      if (allowEdit) return "Valitse puomin pituus";
      else return "Puomin pituutta ei valittu";
    }
    return false;
  }
  linjaError(allowEdit = true) {
    if (this.pumppuLinja < 0 || this.pumppuLinja == null) {
      if (allowEdit) return "Valitse linjan pituus";
      else return "Linjan pituutta ei valittu";
    }
    return false;
  }

  pumppuError(allowEdit = true) {
    const _puomiError = this.puomiError(allowEdit);
    if (_puomiError) return _puomiError;

    const _linjaError = this.linjaError(allowEdit);
    if (_linjaError) return _linjaError;

    return null;
  }

  get pumppuHash() {
    const _puomi = this.pumppuPuomi === null ? -1 : this.pumppuPuomi;
    const _linja = this.pumppuLinja === null ? -1 : this.pumppuLinja;
    let _aika1 = Math.round(this.pumppuAika / 914683);
    let _aika2 = Math.round((this.pumppuAika || 0) / 914683);
    if (isNaN(_aika1)) _aika1 = 0;
    if (isNaN(_aika2)) _aika2 = 0;
    const _kesto = this.pumppuKesto;
    const _aikaTxt = hashCode(this.kellonAikaTxt);
    const _ehdota = this.ehdotaAikaa ? 1 : 0;
    // loop pumppariList
    let _pumppari = 0;
    if (this.pumppariList) {
      for (let i = 0; i < this.pumppariList.length; i++) {
        _pumppari += this.pumppariList[i].personId;
      }
    }
    return (
      _puomi * 7 +
      _linja * 5 +
      _aika1 * 3 +
      _kesto * 110 +
      _aikaTxt * 13 +
      _ehdota * 17 +
      _aika2 * 19 +
      _pumppari * 23
    );
  }
}
